import { Button, Divider, Input, message, Spin } from "antd";
import { FormLabel } from "../form-label";
import styles from "./styles.module.scss";
import { RoleOption } from "../role-option";
import {
  AcademyIcon,
  CountryIcon,
  EmailIcon,
  MobileIcon,
  NameIcon,
  RoleIcon,
  RoleStrikerIcon,
  SelectedTick,
  StudioPlatformIcon,
  TrialIcon,
  WebPlatformIcon,
} from "icons";
import { CustomSelect } from "components/custom-select";
import { useMemo, useState } from "react";
import { FormItem } from "pages/statistics/filterV1/filterModal";
import { ConditionalRenderer, CustomDatePicker } from "components";
import { useCurrentUserContext } from "providers";
import { UseLazyApiCallOldDashboard } from "hooks/use-lazy-api-call-old-dashboard";

export const AddUserModal = ({ getUsers, closeModal, page, size, search }) => {
  const { user } = useCurrentUserContext();

  const platformItems = [
    {
      title: "Mobile Application",
      key: "mobileApplication",
      isActive: true,
      Icon: MobileIcon,
      borderColor: "#006AB3",
    },
    {
      title: "Web Application",
      key: "webApplication",
      isActive: false,
      Icon: WebPlatformIcon,
      borderColor: "#F4BD00",
    },
    {
      title: "Studio Application",
      key: "studioApplication",
      isActive: false,
      Icon: StudioPlatformIcon,
      borderColor: "#78ba2c",
    },
  ];
  const studioObj = {
    title: "Studio",
    icon: StudioPlatformIcon,
    bgColor: "#FFFAED",
  };
  const webObj = {
    title: "Web",
    icon: WebPlatformIcon,
    bgColor: "#E7FFC5",
  };
  const mobileObj = {
    title: "Mobile",
    icon: MobileIcon,
    bgColor: "#EDFDFF",
  };

  const avaialbleData = {
    trial: {
      months: "4 Weeks",
      platforms: [mobileObj],
      id: 1,
    },
    basic: {
      months: "3 Months",
      platforms: [mobileObj],
      id: 2,
    },
    standard: {
      months: "6 Months",
      platforms: [webObj, mobileObj],
      id: 3,
    },
    premium: {
      months: "12 Months",
      platforms: [studioObj, webObj, mobileObj],
      id: 4,
    },
  };

  const [activeOption, setActiveOption] = useState("trial");
  const [selectedData, setSelectedData] = useState(avaialbleData["trial"]);
  const [addUser, { data: addUserData, isLoading: addUserloading, error }] =
    UseLazyApiCallOldDashboard({
      url: "add_user",
      method: "POST",
    });

  const roleOptions = [
    {
      label: "Striker",
      icon: RoleStrikerIcon,
      id: 5,
    },
    {
      label: "Coach",
      icon: RoleStrikerIcon,
      id: 4,
    },
  ];

  let planTypes = [
    {
      title: "Trial",
      key: "trial",
      id: 1,
    },
    {
      title: "Basic",
      key: "basic",
      id: 2,
    },
    {
      title: "Standard",
      key: "standard",
      id: 3,
    },
    {
      title: "Premium",
      key: "premium",
      id: 4,
    },
  ];

  const [platformData, setPlatformData] = useState(platformItems);
  const formInitialData = {
    firstName: "",
    lastName: "",
    email: "",
    roleId: 5,
    country: 3,
    subscription: 1,
    extendedBy: user?.username,
    captureId: "demo",
  };
  const [userFormData, setUserFormData] = useState({
    ...formInitialData,
  });

  async function handleSubmitForm(e) {
    e.preventDefault();

    try {
      const response = await addUser({
        params: userFormData,
      });
      if (response.success) {
        message.success(response.message);
        setUserFormData({ ...setUserFormData });
        closeModal();
        getUsers({
          page,
          size,
          search,
        });
      }
    } catch (error) {
      console.log({ error });
    }
  }
  const planOptions = ["Pakistan", "Bangladesh", "China"];

  function handleChangePlan(e) {}

  function handleChangePlatform(clickedItem) {
    const newdata = platformData?.map((itemObj) =>
      clickedItem.title === itemObj.title
        ? { ...itemObj, isActive: true }
        : { ...itemObj, isActive: false }
    );

    setPlatformData(newdata);
  }

  const selectedOption = useMemo(
    () => platformData?.find((item) => item?.isActive),
    [platformData]
  );

  function handleClickOption(option) {
    setActiveOption(option.key);
    setSelectedData(avaialbleData[option.key]);
    setUserFormData((prev) => {
      return { ...prev, subscription: option.id };
    });
  }

  function handleChangeForm(e) {
    const { name, value } = e.target;
    setUserFormData((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  }

  return (
    <div className={styles.addUserContainer}>
      <Spin spinning={addUserloading}>
        <form onSubmit={handleSubmitForm}>
          <h3>Add New User</h3>
          <div className={styles.desc}>
            Please enter details below to continue
          </div>
          <div className={styles.name}>
            <div>
              <FormLabel label="First Name" required Icon={NameIcon} />
              <Input
                style={{ height: "48px" }}
                type="text"
                placeholder="Enter First Name"
                required
                value={userFormData.firstName}
                onChange={handleChangeForm}
                name="firstName"
              />
            </div>
            <div>
              <FormLabel label="Last Name" required Icon={NameIcon} />
              <Input
                style={{ height: "48px" }}
                type="text"
                placeholder="Enter Last Name"
                required
                value={userFormData.lastName}
                onChange={handleChangeForm}
                name="lastName"
              />
            </div>
          </div>
          <div>
            <FormLabel label="Email Address" required Icon={EmailIcon} />
            <Input
              style={{ height: "48px" }}
              type="email"
              placeholder="Enter email"
              required
              value={userFormData.email}
              onChange={handleChangeForm}
              name="email"
            />
          </div>
          <div>
            <FormLabel label="Role" required Icon={RoleIcon} />

            <div className={styles.roleOptions}>
              {roleOptions?.map((item) => (
                <div
                  key={item.id}
                  onClick={() =>
                    setUserFormData({ ...userFormData, roleId: item.id })
                  }
                >
                  <RoleOption
                    label={item.label}
                    Icon={item.icon}
                    isActive={userFormData.roleId === item.id}
                  />
                </div>
              ))}
            </div>
          </div>
          <FormLabel label="Country" required Icon={CountryIcon} />
          <CustomSelect
            defaultValue={"Pakistan"}
            optionsArray={planOptions}
            style={{
              select: {
                width: "100%",
              },
            }}
            variant="user-detail"
            onChange={handleChangePlan}
          />
          {/* <div>
          <FormLabel label="Academy Code" required Icon={AcademyIcon} />
          <Input
            style={{ height: "48px" }}
            type="text"
            placeholder="Academy Code (Optional)"
          />
        </div> */}
          <div className={styles.extendPlan}>
            <h3 className={styles.title}>Select Subscription</h3>
            <p>
              You can extend, reduce, or modify user subscriptions at any time
              based on their access needs.
            </p>
            <Divider style={{ margin: "10px 0px" }} />

            <div className={styles.select}>Select</div>

            <div className={styles.planSelection}>
              <div className={styles.planOptions}>
                {planTypes?.map((item) => {
                  const isActive = activeOption === item.key;

                  return (
                    <div
                      key={item.key}
                      className={`${styles.singlePlanOption} ${
                        isActive && styles.active
                      }`}
                      onClick={() => handleClickOption(item)}
                    >
                      <div className={styles.title}>{item.title}</div>
                      <ConditionalRenderer condition={isActive}>
                        <SelectedTick />
                      </ConditionalRenderer>
                      <ConditionalRenderer condition={!isActive}>
                        <div className={`${styles.radioBtn}`}></div>
                      </ConditionalRenderer>
                    </div>
                  );
                })}
              </div>
            </div>
            <div className={styles.selectedOptionData}>
              <div className={styles.months}>{selectedData?.months}</div>

              <div className={styles.platforms}>
                {selectedData?.platforms?.map((item) => (
                  <div
                    key={item.title}
                    style={{ backgroundColor: `${item.bgColor}` }}
                    className={styles.singlePlatform}
                  >
                    <item.icon height={15} width={15} /> {item.title}
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* <Divider />
        <div className={styles.platformSelection}>
          <FormLabel
            label="Select Application"
            required
            className={styles.platformLabel}
          />

          <p>Select the application you want to grant access to.</p>

          <div className={styles.platformItems}>
            {platformData?.map((item) => (
              <div
                key={item.key}
                style={{ borderLeft: `6px solid ${item.borderColor}` }}
                className={
                  styles[
                    selectedOption?.isActive === item?.isActive
                      ? "activeSingleItem"
                      : "singleItem"
                  ]
                }
                onClick={() => handleChangePlatform(item)}
              >
                <item.Icon />
                <div>{item.title}</div>
              </div>
            ))}
          </div>
        </div>
        <Divider />
        <div className={styles.timeSelection}>
          <FormLabel
            label="Subscription"
            required
            className={styles.timeLabel}
          />

          <p>Select the subscription you want to assign to the user.</p>
          <div className={styles.timeOptions}>
            <div className={styles.trialOption}>
              <TrialIcon />
              <div>Trial (4 weeks)</div>
            </div>
            <div style={{ width: "30%" }}>
              <FormLabel label="Start Date" className={styles.dateLabel} />
              <CustomDatePicker
                // value={expiryDateData?.extendedDate}
                disabled={true}
              />
            </div>
            <div style={{ width: "30%" }}>
              <FormLabel label="End Date" className={styles.dateLabel} />
              <CustomDatePicker
                // value={expiryDateData?.extendedDate}
                disabled={true}
              />
            </div>
          </div>
        </div> */}
          <Button className={styles.addBtn} size="large" htmlType="submit">
            Add User
          </Button>
        </form>
      </Spin>
    </div>
  );
};
